module.exports = __webpack_public_path__ + "media/1x1/lc-c056c2a7.svg";